import { components, ValueContainerProps } from "react-select";

const CustomValueContainer = (
  props: ValueContainerProps<{ label: string; value: string }, true>
) => {
  const { getValue, children } = props;
  const selectedCount = getValue().length;
  const selectedLabels = getValue()
    .map((opt) => opt.label)
    .join(", ");

  const truncatedStyle: React.CSSProperties = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    position: "absolute",
  };

  return (
    <components.ValueContainer {...props}>
      {selectedCount > 0 ? (
        <span style={truncatedStyle}>{selectedLabels}</span>
      ) : (
        children
      )}
    </components.ValueContainer>
  );
};
export default CustomValueContainer;
